import { createIcon } from '@chakra-ui/react';

export const IconInstitute = createIcon({
  displayName: 'IconInstitute',
  viewBox: '0 0 40 40',
  defaultProps: {
    height: '40px',
    width: '40px',
  },
  path: (
    <g fill="none">
      <path
        d="M3.55553 16.3604V31.4373"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M10.8248 16.3604V31.4373"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M17.8248 16.3604V31.4373"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M25.094 31.4373V16.3604"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M14.3248 8L0.324799 12.8077L14.3248 11L28.3248 12.8077L14.3248 8Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </g>
  ),
});
